"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useActiveElement = () => {
  const [active, setActive] = (0, _react.useState)(document.activeElement);
  const handleFocusIn = () => {
    setActive(document.activeElement);
  };
  const hasParent = id => {
    return active.closest("[id^=".concat(id, "]")) !== null;
  };
  (0, _react.useEffect)(() => {
    document.addEventListener('focusin', handleFocusIn);
    return () => {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, []);
  return {
    active,
    hasParent
  };
};
var _default = exports.default = useActiveElement;